import {
  isPermissionsEnabled,
  PERMISSION_ACTIONS,
  PERMISSION_VERBS,
} from '~/components/core/Permissions/PermissionUtils';
import { useCms } from '~/components/hooks/useCms';
import { useHasPermission } from '~/components/hooks/useHasPermission';
import useOrganization from '~/components/OrganizationContext';
import { CONFIGURATION_FEATURES_NAMES } from '~/Types';
import { isFeatureEnabled } from '~/Utils';

interface OrganizationContextType {
  orgAdditionalConfigs: {
    email_classifier_user_ids?: string[];
  };
  isFnolInboxConfigured: boolean;
}

interface GQClassificationConfig {
  isAllowedToPerformAction: boolean;
  isMoveToFnolEnabled: boolean;
  isFnolCategoryClassificationEnabled: boolean;
}

export function useGQClassification(): GQClassificationConfig {
  const { user, userOrganization } = useCms();
  const { orgAdditionalConfigs, isFnolInboxConfigured } = useOrganization() as OrganizationContextType;

  const isMoveToFnolEnabled = isFnolInboxConfigured;
  const isFnolCategoryClassificationEnabled = isFeatureEnabled(
    userOrganization,
    CONFIGURATION_FEATURES_NAMES.CLIVE_GQ_FNOL_CATEGORY_CLASSIFICATION_DISPLAY
  );

  const userHasEmailClassificationPermissions = useHasPermission({
    action: PERMISSION_ACTIONS.GENERAL_EMAIL_CLASSIFICATION,
    verb: PERMISSION_VERBS.WRITE,
  });

  const isAllowedToPerformAction = isPermissionsEnabled(userOrganization)
    ? userHasEmailClassificationPermissions
    : (orgAdditionalConfigs?.email_classifier_user_ids?.includes(user.id) ?? false);

  return {
    isAllowedToPerformAction,
    isMoveToFnolEnabled,
    isFnolCategoryClassificationEnabled,
  };
}
